import * as Yup from "yup";

//  validations schemas
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email")
    .email("Invalid email address")
    .required("Email is required*"),
  password: Yup.string().trim().required("Password is required*"),
});

const agronomistValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required*"),

  firstName: Yup.string().trim().required("First name is required*"),

  lastName: Yup.string().trim().required("Last name is required*"),

  countryCode: Yup.string().trim(),
  phoneNumber: Yup.string().trim().required("Phone number is required*"),

  location: Yup.string().trim().required("Location is required*"),
  agronomistFile: Yup.string(),
});
const cropValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required*"),
});

const profileValidationSchema = Yup.object().shape({
  profileImage: Yup.string().trim(),
  fullName: Yup.string().trim().required("Full name is required*"),
  emailAddress: Yup.string()
    .trim()
    .email("Invalid email")
    .required("Email address is required*"),
});
const changePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().trim().required("Old Password is required*"),
  password: Yup.string().trim().required("Password is required*"),
  confirmPassword: Yup.string()
    .trim()
    .oneOf([Yup.ref("password")], "Password must match*")
    .required("Confirm your password*"),
});
const productValidationSchema = Yup.object().shape({
  productName: Yup.string().trim().required("Product name is required*"),
  containerSize: Yup.string().trim().required("Container size is required*"),
  containerUnit: Yup.string().trim().required("Container unit is required*"),
  containerType: Yup.string().trim().required("Container type is required*"),
  rate: Yup.string().trim().required("Rate is required*"),
  rateUnit: Yup.string().required("Rate unit is required"),

});

const growerValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required*"),

  firstName: Yup.string().trim().required("First name is required*"),

  lastName: Yup.string().trim().required("Last name is required*"),

  countryCode: Yup.string().trim(),

  phoneNumber: Yup.string().trim().required("Phone number is required*"),

  location: Yup.string().trim().required("Location is required*"),
  growerFile: Yup.string(),
});
const yearValidationSchema = Yup.object().shape({
  seasonId: Yup.string().required("year is required*"),
  year: Yup.string().required("year is required*"),
});

const scoutingValidationSchema = Yup.object().shape({
  scoutTime: Yup.string(),
  mixSheetFile: Yup.string(),
});

const addCropPlanValidationSchema = (existingYears = []) =>
  Yup.object().shape({
    growingSeason: Yup.string().required("Growing season is required"),
    description: Yup.string().trim(),
    planStatus: Yup.string().trim(),
  });

export {
  validationSchema,
  agronomistValidationSchema,
  profileValidationSchema,
  changePasswordValidationSchema,
  productValidationSchema,
  growerValidationSchema,
  cropValidationSchema,
  yearValidationSchema,
  scoutingValidationSchema,
  addCropPlanValidationSchema,
};
